import React from "react";
import Heading from "../components/common/Heading";
import About from "../components/home/About";
import { AdminLogin } from "../components/adminPanel/login";

export default function Login() {
  return (
    <>
      {/* <Heading heading="About Us" title="Home" subtitle="About" /> */}
      {/* need to add banner */}
      <AdminLogin />
    </>
  );
}
